import type { ReactElement, ReactNode } from 'react'

import Step from './Step'

interface Props {
  steps: {
    circleText: string
    content: ReactNode
  }[]
}

const Stepper = ({ steps }: Props): ReactElement => {
  return (
    <div className="stepper-component">
      {steps.map(({ circleText, content }) => (
        <Step key={`step-${circleText}`} {...{ circleText, content }} />
      ))}
    </div>
  )
}

export default Stepper
